import styles from "./assets/css/WelcomeSection.module.css";
import { Link, useLocation } from "react-router-dom";

import riderMobile from "./assets/img/rider_mobile.webp";
import rider from "./assets/img/rider.webp";
import { useEffect, useRef, useState } from "react";

const WelcomeSection = () => {
  const { pathname } = useLocation();
  const [slideIn, setSlideIn] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);
  const riderRef = useRef();
  const textContainerRef = useRef();

  useEffect(() => {
    if (!riderRef.current) return;
    if (!textContainerRef.current) return;

    const options = {
      root: null,
      rootMargin: "50%",
      threshold: 1,
    };

    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setSlideIn(true);
          setFadeIn(true);
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);

    observer.observe(riderRef.current);
    observer.observe(textContainerRef.current);
  }, [pathname]);

  return (
    <>
      <div className={styles.sectionGradient}></div>
      <section id="welcome" className={styles.welcomeSection}>
        <div className={`${styles.welcomeContainer} container`}>
          <div
            className={`${styles.textContainer} ${fadeIn ? styles.fadeIn : ""}`}
            ref={textContainerRef}
          >
            <h2 className={styles.title}>Welcome To Technical Touch</h2>
            <p className={styles.text}>
              Technical Touch was founded by the owner Jan Berthels over 30
              years ago, back in 1992. What started out as a one-man-business
              would overtime become a well-known name in the MX/ENDURO world.
            </p>
            <p className={styles.text}>
              In the company’s early days, Jan developed his contacts and
              knowledge with KYB Suspensions in Japan and in the MX world. He
              was the personal suspension mechanic for ex-World champion MotoGP
              Kevin Schwantz and for none other than one of the greats in the MX
              world: Stefan Everts.
            </p>
            <Link to={"/about"} className={styles.moreInfo}>
              Find Out More
            </Link>
          </div>
          <div className={styles.riderContainer} ref={riderRef}>
            <img
              src={rider}
              className={`${styles.rider} ${slideIn ? styles.slideIn : ""}`}
              alt="motorbike and rider sliding into view"
              width={614}
              height={345}
            />
          </div>
        </div>

        <div className={styles.riderMobileContainer}>
          <img
            src={riderMobile}
            className={styles.riderMobile}
            alt="motorbike and rider sliding into view"
            width={"802"}
            height={"678"}
          />
        </div>
      </section>
    </>
  );
};
export default WelcomeSection;
